/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvidencesInnerValue
 */
export interface EvidencesInnerValue {
}

/**
 * Check if a given object implements the EvidencesInnerValue interface.
 */
export function instanceOfEvidencesInnerValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EvidencesInnerValueFromJSON(json: any): EvidencesInnerValue {
    return EvidencesInnerValueFromJSONTyped(json, false);
}

export function EvidencesInnerValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidencesInnerValue {
    return json;
}

export function EvidencesInnerValueToJSON(value?: EvidencesInnerValue | null): any {
    return value;
}

